import { create } from 'zustand'
import type { FeedbackEntryPoint } from './api'

type State = {
  isOpen: boolean
  entryPoint: FeedbackEntryPoint
  /** Pre-populated message text (e.g. when opened from an error boundary). */
  prefill: string | null
  /** Caller-supplied event id to attach to the feedback row (Sentry/GlitchTip). */
  sentryEventId: string | null
}

type Actions = {
  open: (opts?: { entryPoint?: FeedbackEntryPoint; prefill?: string; sentryEventId?: string }) => void
  close: () => void
}

export const useFeedbackStore = create<State & Actions>((set) => ({
  isOpen: false,
  entryPoint: 'cmd_k',
  prefill: null,
  sentryEventId: null,

  open: (opts) =>
    set({
      isOpen: true,
      entryPoint: opts?.entryPoint ?? 'cmd_k',
      prefill: opts?.prefill ?? null,
      sentryEventId: opts?.sentryEventId ?? null,
    }),

  close: () => set({ isOpen: false, prefill: null, sentryEventId: null, entryPoint: 'cmd_k' }),
}))
